<template>
  <div class="page" v-if="showFlg">
    <div>
      <span class="prev" :class="{'no-resize':pageNo == 1}" @click="loadData(pageNo - 1)">&lt;&lt;</span>
      <span v-for="(item,index) in pageList" :key="index" :class="{'on':item.val==pageNo}" @click="loadData(item.val)">{{item.text}}</span>
      <span v-if="totalPage > pagegroup" :class="{'on':totalPage==pageNo}" @click="loadData(totalPage)">{{totalPage}}</span>
      <span class="next" :class="{'no-resize':pageNo == this.totalPage}" @click="loadData(pageNo + 1)">&gt;&gt;</span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["dataObj"],
  data() {
    return {
      showFlg: false,
      // 分页条数 -- 奇数
      pagegroup: 4,
      //总页数
      totalPage: 1,
      //页面大小
      pageSize: 0,
      //当前页码
      pageNo: 1,

      pageList: []
    };
  },
  computed: {},
  methods: {
    loadData(pageNo) {
      if (pageNo > 0 && pageNo <= this.totalPage) {
        this.$emit("nextPage", pageNo);
      }
    },
    grouplist(totalPage, pagegroup, pageNo) {
      // 获取分页页码
      let len = totalPage,
        temp = [],
        list = [],
        count = Math.floor(pagegroup / 2),
        center = pageNo;
      if (len <= pagegroup) {
        while (len--) {
          temp.push({ text: totalPage - len, val: totalPage - len });
        }
        return temp;
      }
      while (len--) {
        temp.push(totalPage - len);
      }
      let idx = temp.indexOf(center);
      idx < count && (center = center + count - idx);
      pageNo > totalPage - count && (center = totalPage - count);
      temp = temp.splice(center - count - 1, pagegroup);
      do {
        let t = temp.shift();
        list.push({
          text: t,
          val: t
        });
      } while (temp.length);
      if (totalPage > pagegroup) {
        pageNo > count + 1 &&
          list.unshift({ text: "...", val: list[0].val - 1 });
        pageNo < totalPage - count &&
          list.push({ text: "...", val: list[list.length - 1].val + 1 });
      }
      return list;
    }
  },
  watch: {
    dataObj: function(val,oldval) {
      if (val && Math.ceil(val.total/val.count) > 1) {
        this.showFlg = true;
        // console.log(val);
        this.totalPage = Math.ceil(val.total/val.count);
        this.pageSize = val.count*1;
        this.pageNo = val.page*1;
        this.pageList = this.grouplist(
          this.totalPage,
          this.pagegroup,
          this.pageNo
        );
      }
      else{
         this.showFlg = false;
      }
    }
  }
};
</script>
<style scoped>
.page {
    text-align: center;
    padding-top: 50px;
}

.page div {
    display: inline-block;
}

.page div span {
    width: 30px;
    height: 30px;
    float: left;
    border: 1px solid #e6e6e6;
    line-height: 28px;
    color: #666;
    margin-right: 8px;
    background: #fff;
    cursor: pointer;
}

.page div span:hover,
.page div span.on {
    background: #194EB0;
    color: #fff;
    border: 1px solid #194EB0;
}

.page div .prev,
.page div .next {
    width: 30px;
    color: #194EB0;
}

.page div .more {
    border: none;
}
.no-resize{
  cursor:not-allowed!important;
}
.no-resize:hover{
   background: #fff!important;
    color: #194EB0!important;
    border: 1px solid #e6e6e6!important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/common/ModelPage.vue